import Portis from '@portis/web3';
import { treasury } from '../stateManagement/Treasury';
import { stateEventObserver } from './EventObserver';
import EventTypes from '../constants/eventTypes';
import { WALLET_TYPES } from '../constants/wallet';
import { getAccounts } from './utils';

let portis: undefined | Portis;

export const removePortisEventListeners = () => {
  if (portis) {
    portis.onLogout(() => {});
    portis.onActiveWalletChanged(() => {});
    portis.onError(() => {});
  }
};

// https://docs.portis.io/#/methods
const subscribePortisEvents = async ({ rpcUrl, networkId }: { rpcUrl: string, networkId: number }) => {
  const unlockedAccount = await getAccounts(portis.provider);
  portis.onLogout(() => {
    stateEventObserver.emit(EventTypes.DISCONNECT, null);
  });
  portis.onActiveWalletChanged((walletAddress) => {
    if (walletAddress?.toLowerCase() !== unlockedAccount?.toLowerCase()) {
      stateEventObserver.emit(EventTypes.DISCONNECT, null);
      stateEventObserver.emit(EventTypes.CONNECT_REQUEST_COMPONENT, { rpcUrl, networkId, connectionType: WALLET_TYPES.portis });
    }
  });
  portis.onError((error) => {
    stateEventObserver.emit(EventTypes.CONNECT_ERROR_COMPONENT, error);
  });
};

export const getPortisProvider = async (rpcUrl: string, networkId: number) => {
  const network = {
    nodeUrl: rpcUrl,
    chainId: networkId.toString(),
  };
  if (portis && await portis.isLoggedIn()) {
    portis.changeNetwork(network);
  } else {
    portis = new Portis(treasury.portis, network);
    await portis.provider.enable();
  }
  subscribePortisEvents({ rpcUrl, networkId });
  return { provider: portis.provider, connector: portis };
};
